import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import './IataField.css';

export default function IataField(props: {
  label: string;
  iataChanged: (value: string | null) => void;
  iatas: string[];
  selectedIata: string | null;
  width?: number;
}) {
  const [value, setValue] = React.useState<string | null>(props.selectedIata || null);

  return (
    <Autocomplete
      className="iata-field"
      disablePortal
      options={props.iatas}
      onChange={(e, v) => {
        props.iataChanged(v);
        setValue(v);
      }}
      sx={{ width: props.width }}
      renderInput={params => <TextField {...params} label={props.label}/>}
      value={value}
    />
  );
}
